import {
  Checkbox,
  Flex,
  FlexItem,
  FormElement,
  Select
} from 'mailup-web-components'
import {
  otherFiltersState,
  taskConditionsState
} from 'Pages/Task/recoil/state/task'

import { useIntl } from 'react-intl'
import { useRecoilState, useRecoilValue } from 'recoil'

const ConditionsOtherFilterFalse = () => {
  const [{ OtherFilterFalse, OtherFilterFalseId }, setTaskConditionsState] =
    useRecoilState(taskConditionsState)
  const { items } = useRecoilValue(otherFiltersState)
  const intl = useIntl()
  const onChangeConditionsAnagraphicFilterFalse = () => {
    setTaskConditionsState((prev) => ({
      ...prev,
      OtherFilterFalse: !prev.OtherFilterFalse,
      isDirty: true
    }))
  }

  const onChangeOtherFilterFalseId = (val) => {
    setTaskConditionsState((prev) => ({
      ...prev,
      OtherFilterFalseId: val,
      isDirty: true
    }))
  }

  return (
    <>
      <Flex alignItems='flex-start'>
        <FlexItem margin='10px 0 0 0'>
          <Checkbox
            checked={OtherFilterFalse}
            onChange={onChangeConditionsAnagraphicFilterFalse}
            label={intl.formatMessage(
              { id: 'Load.Task.ConditionsOtherFilterFalse' },
              {
                strong: (str) => <strong>{str}</strong>
              }
            )}
            data-mu-test='checkBox-ConditionsAnagraphicFilterFalse'
          />
        </FlexItem>
        <Flex display='block' margin='0 8px' minWidth='300px'>
          <FormElement
            feedback={
              OtherFilterFalse && !OtherFilterFalseId
                ? intl.formatMessage({ id: 'Load.MailupCommon.Required' })
                : null
            }
          >
            <Select
              value={OtherFilterFalseId}
              onChange={onChangeOtherFilterFalseId}
              searchable
              placeholder={intl.formatMessage({
                id: 'Load.Task.ConditionsOtherFilterPlaceholder'
              })}
              disabled={!OtherFilterFalse}
              options={items}
              error={OtherFilterFalse && !OtherFilterFalseId ? 'danger' : null}
            />
          </FormElement>
        </Flex>
      </Flex>
    </>
  )
}

export default ConditionsOtherFilterFalse
